import {
  QueryBuilderAstNodeType,
  QueryBuilderShareQueryConfigType,
} from '../../types';

type UseQueryBuilderShareArgsType = {
  shareQuery: QueryBuilderShareQueryConfigType;
};

type UseQueryBuilderShareReturnType = {
  handleShareQuery: (ast: QueryBuilderAstNodeType) => void;
};

export const useQueryBuilderShare = ({
  shareQuery,
}: UseQueryBuilderShareArgsType): UseQueryBuilderShareReturnType => {
  const handleShareQuery = (ast: QueryBuilderAstNodeType): void => {
    shareQuery.mutate(ast, {
      onSuccess: (uuid): void => {
        const shareUrl = shareQuery.buildShareUrl(uuid);

        void navigator.clipboard.writeText(shareUrl);
        shareQuery.onSuccess?.(uuid);
      },
      onError: (error): void => {
        shareQuery.onError?.(error);
      },
    });
  };

  return { handleShareQuery };
};
